import { FC, Fragment } from 'react'
import { FormDataConsumer, SelectInput, required } from 'react-admin'
import CertificatesInterfaceSelect from './ZakenCertificatesInterfaceSelect'

export const CertificatesCreatePKI: FC = () => (
  <Fragment>
    <SelectInput
      source="metaData.samlKoppeling"
      label="resources.certificates.fields.samlKoppeling"
      choices={[
        { id: 'samlidp', name: 'resources.certificates.fields.samlidp' },
        // { id: 'adfs', name: 'resources.certificates.fields.saml_adfs' },
        // { id: 'samlsp', name: 'resources.certificates.fields.saml_sp' },
      ]}
      defaultValue="samlidp"
      helperText="resources.certificates.fields.samlKoppeling_help"
      fullWidth
      validate={[required()]}
    />
    <FormDataConsumer>
      {({ formData }: { formData: { metaData?: { instanceId?: string; samlKoppeling?: string } } }) =>
        formData.metaData?.samlKoppeling && (
        <CertificatesInterfaceSelect
            instanceId={formData.metaData.instanceId}
            module={formData.metaData.samlKoppeling}
          />
      )}
    </FormDataConsumer>
  </Fragment>
)